import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'ws-scripts/modules/common';

const VehicleAttributeItem = ({ name, labeledValue, value, swatchColor }) => {
	const prefs = usePrefs();

	const isComment = name === 'comments';
	const isAccountName = name === 'accountName';

	const liClassNames = setClassNames([
		swatchColor ? 'normalized-swatch-container' : null,
		name
	]);

	let children = null;
	if (swatchColor) {
		children = (
			<>
				<span
					className={setClassNames([
						'normalized-swatch',
						`normalized-swatch-${swatchColor}`
					])}
				/>
				{labeledValue}
			</>
		);
	} else if (isAccountName) {
		// Visually, display a map pin icon and the account name (the attribute's value).
		// The accessible name is the attribute's labeledValue, which is the account name prefixed with the word "Location: ".
		children = (
			<>
				<span className="sr-only">{labeledValue}</span>
				<i
					className="ddc-icon ddc-icon-map align-middle pr-2"
					aria-hidden="true"
				/>
				<span aria-hidden="true">{value}</span>
			</>
		);
	} else if (isComment) {
		children = (
			/* eslint react/no-danger: 0 */
			/* comments need nested span for line-clamp css to work with multiple paragraphs in firefox */
			<span
				className={`line-clamp-${prefs.commentsTruncateLines} text-break`}
			>
				<span
					dangerouslySetInnerHTML={{
						__html: labeledValue
					}}
				/>
			</span>
		);
	}

	return (
		<li
			className={liClassNames}
			{...(!children && {
				dangerouslySetInnerHTML: { __html: labeledValue }
			})}
		>
			{children}
		</li>
	);
};

VehicleAttributeItem.propTypes = {
	name: PropTypes.string.isRequired,
	labeledValue: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	swatchColor: PropTypes.string
};

VehicleAttributeItem.defaultProps = {
	swatchColor: null
};

export default VehicleAttributeItem;
